angular
    .module("skillBuilderSaaS")
    .filter("lowercaseFirst", function () {
    return function (input) {
        return (angular.isString(input) && input.length > 0) ? input.charAt(0).toLowerCase() + input.substr(1) : input;
    };
});
